import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IAgentOptionsItem, IPageParam, IServerOptionsItem } from '../../types/common';
import { IDistributionSettlement, IDistributionTaskAddRequest, IDistributionTaskDetail, IDistributionTaskPageRequest } from '../../types/crowd-source/commission-share';
const hostUrl = getHostbaseUrl();

export async function queryDistributionTaskPage(param: IDistributionTaskPageRequest) {
  let data = [] as IDistributionTaskDetail[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IPageParam;

  try {
    const { code, context, message } = await Http.post<{ data: IDistributionTaskDetail[]; total: number }>(`${hostUrl}/report/crowd/distributionTask/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IDistributionTaskDetail[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 新增分润任务
 */
export async function addDistributionTask(param: IDistributionTaskAddRequest) {
  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/report/crowd/distributionTask/add`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 编辑分润任务
 */
export async function editDistributionTask(param: IDistributionTaskAddRequest) {
  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/report/crowd/distributionTask/edit`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 作废分润任务
 */
export async function cancelDistributionTask(param: { id: number }) {
  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/report/crowd/distributionTask/cancel`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 提交分润任务
 */
export async function submitDistributionTask(param: { id: number }) {
  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/report/crowd/distributionTask/submit`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 分润任务导出
 */
export async function exportDistributionTask(param: IDistributionTaskPageRequest) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/report/crowd/distributionTask/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/** 结算单列表 */
export async function queryDistributionTaskDetailPage(param: { id: number }) {
  let data = [] as IDistributionSettlement[];
  let settlementDateStart = '';
  let settlementDateEnd = '';

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/report/crowd/distributionTask/detail`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { resultList: items, settlementDateStart: start, settlementDateEnd: end } = context || {} as { resultList: IDistributionSettlement[]; settlementDateStart: string; settlementDateEnd: string };

      data = items || [];
      settlementDateStart = start || '';
      settlementDateEnd = end || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return {
    data,
    settlementDateStart,
    settlementDateEnd,
  };
}

/**
 * 结算单导出
 */
export async function exportDistributionTaskDetail(param: { id: number }) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/report/crowd/distributionTask/detail/export`,
      param,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 *查询有分润任务的服务商
 */
export async function queryServerListForCommission() {
  let data = [] as IServerOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IServerOptionsItem>>(`${hostUrl}/report/crowd/side/server/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 查询有分润任务的代理商
 */
export async function queryAgentListForCommission() {
  let data = [] as IAgentOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IAgentOptionsItem>>(`${hostUrl}/report/crowd/side/agent/list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}